import React from "react";
import "./styles.scss";

const PINCode = ({ pinLength = 0, pin, hasError, errorMessage }) => {
  const renderDots = () => {
    const dots = [];
    for (let i = 0; i < pinLength; i++) {
      dots.push(
        <span
          key={i}
          className={`dot ${i < pin.length ? "filled-dot" : "unfilled-dot"} ${
            hasError && "error-dot"
          }`}
        />
      );
    }
    return dots;
  };

  return (
    <div dir="ltr" className="pin-code-container">
      <div className="dot-container">{renderDots()}</div>
      {hasError && !!errorMessage && (
        <p className="error-text">{errorMessage}</p>
      )}
    </div>
  );
};

export default PINCode;
